// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__bpI2w","modal":"Modal_modal__uOZ8u"};